export function NorthVancouverCTA() {
  const handleAssessment = () => {
    window.REACT_APP_NAVIGATE('/property-assessment');
  };

  return (
    <section id="contact" className="py-24 lg:py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
          Navigate North Vancouver STR Compliance with Confidence
        </h2>
        <p className="text-xl text-[#505A5A]/70 mb-10 leading-relaxed max-w-3xl mx-auto">
          Whether you're in the District or City of North Vancouver, we handle the complex zoning regulations, licensing process, and ongoing compliance so you can focus on hosting.
        </p>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-[#F0F0F0] rounded-2xl p-8">
            <div className="w-14 h-14 flex items-center justify-center bg-[#882629] rounded-xl mx-auto mb-4">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-[#505A5A] mb-2">
              Jurisdiction Expertise
            </h3>
            <p className="text-sm text-[#505A5A]/70">
              We know the differences between District and City regulations
            </p>
          </div>

          <div className="bg-[#F0F0F0] rounded-2xl p-8">
            <div className="w-14 h-14 flex items-center justify-center bg-[#882629] rounded-xl mx-auto mb-4">
              <i className="ri-file-list-3-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-[#505A5A] mb-2">
              Complete Licensing
            </h3>
            <p className="text-sm text-[#505A5A]/70">
              We handle your entire application from start to approval
            </p>
          </div>

          <div className="bg-[#F0F0F0] rounded-2xl p-8">
            <div className="w-14 h-14 flex items-center justify-center bg-[#882629] rounded-xl mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-[#505A5A] mb-2">
              Ongoing Support
            </h3>
            <p className="text-sm text-[#505A5A]/70">
              Stay compliant with zoning changes and renewal requirements
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={handleAssessment}
            className="bg-[#882629] text-white px-10 py-5 rounded-full text-lg font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl inline-flex items-center gap-3"
          >
            <i className="ri-mail-line text-xl"></i>
            Get North Vancouver Help
          </button>
          <a 
            href="tel:+17783869229"
            className="bg-white text-[#882629] border-2 border-[#882629] px-10 py-5 rounded-full text-lg font-medium hover:bg-[#882629] hover:text-white transition-all cursor-pointer whitespace-nowrap shadow-lg inline-flex items-center gap-3"
          >
            <i className="ri-phone-line text-xl"></i>
            +1 (778) 386-9229
          </a>
        </div>

        <p className="text-sm text-[#505A5A]/60 mt-8 italic">
          Based on current 2026 BC Short Term Rental regulations and North Vancouver municipal enforcement policies.
        </p>
      </div>
    </section>
  );
}
